import { render } from "./KalaY.vue?vue&type=template&id=5a845d1a&scoped=true"
import script from "./KalaY.vue?vue&type=script&lang=js"
export * from "./KalaY.vue?vue&type=script&lang=js"

import "./KalaY.vue?vue&type=style&index=0&id=5a845d1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a845d1a"]])

export default __exports__